"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function getErrors(subscription, form_errors, status, preview) {
    if (form_errors.length || subscription.errors.length) {
        return form_errors || subscription.errors;
    }
    if (status) {
        return [{ message: 'Betaling mislukt, probeer het nog eens!' }];
    }
    return [];
}
function FormButtons(_a) {
    var owner_id = _a.owner_id, plan = _a.plan, _b = _a.params, params = _b === void 0 ? {} : _b, errors = _a.errors, status = _a.status, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    var _d = react_1.useState(false), checked = _d[0], setChecked = _d[1];
    var _e = react_1.useState(errors || []), form_errors = _e[0], setErrors = _e[1];
    var _f = ra_fetch_1.useApi('ecommerce')
        .store('subscriptions', __assign(__assign({}, params), { owner_id: owner_id, channel_id: owner_id, plan: plan.name })), subscription = _f[0], setSubscription = _f[1], submitSubscription = _f[2];
    react_1.useEffect(function () {
        if (subscription.data.owner_id !== owner_id) {
            setSubscription({ owner_id: owner_id, channel_id: owner_id });
        }
    }, [owner_id]);
    react_1.useEffect(function () {
        if (checked) {
            setErrors(errors || []);
        }
    }, [checked]);
    react_1.useEffect(function () {
        if (errors && errors.length !== form_errors.length) {
            setErrors(errors);
        }
    }, [errors]);
    function onSubmit(type) {
        if (!checked) {
            return setErrors([{ message: 'Om je te abonneren moet je akkoord gaan met de algemene voorwaarden' }]);
        }
        submitSubscription({ type: type }).then(function (response) {
            if (response.errors.length) {
                return setErrors(response.errors);
            }
            window.location.href = response.data.url;
        });
    }
    return react_1.default.createElement(react_1.default.Fragment, null,
        !disabled && react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Forms.Checkbox, { id: 'conditions', checked: checked, onChange: function (checked) { return setChecked(checked); } },
                "Ik ga akkoord met de ",
                react_1.default.createElement("a", { href: '#', className: 'storybook-subscriptions-anchor' }, "Voorwaarden voor Abonnementen"))),
        react_1.default.createElement(storybook_1.Forms.Buttons, { loading: subscription.submitting, className: 'storybook-subscriptions-buttons', errors: getErrors(subscription, form_errors, status) },
            react_1.default.createElement(storybook_1.Buttons.Button, { disabled: form_errors.length || disabled, type: 'primary', className: 'storybook-subscriptions-button', onClick: function () { return onSubmit('year'); } },
                "\u20AC",
                plan.year,
                " / jaar",
                react_1.default.createElement("span", null, "jaarlijks opzegbaar")),
            react_1.default.createElement(storybook_1.Buttons.Button, { disabled: form_errors.length || disabled, type: 'primary', className: 'storybook-subscriptions-button', onClick: function () { return onSubmit('month'); } },
                "\u20AC",
                plan.month,
                " / maand",
                react_1.default.createElement("span", null, "maandelijks opzegbaar"))));
}
exports.default = FormButtons;
